// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__3BUSK","detailsBorder":"styles_detailsBorder__3poiK"};